<ng-container
  *ngIf="authService.isEvaluating()"
>
<div
  class="wrapper"
>
  <div class="spinner-border text-primary">
    <span class="sr-only">Laden...</span>
  </div>
</div>
</ng-container>
